<div class="container-fluid p-5">
  <h1>Profile</h1>

  @if (currentUser) {
    <div>
      <div>
        <label>Name:</label> {{currentUser.firstName}} {{currentUser.lastName}}
      </div>
      <div>
        <label>Email:</label> {{currentUser.email}}
      </div>
    </div>
  }

  <h2 class="mt-4">Change Password</h2>
  <form [formGroup]="changePasswordForm" (ngSubmit)="submit()" #ngForm="ngForm">
    <div class="form-group col-md-12 pb-2">
      <label for="newPassword" class="required">Password</label>
      <div class="input-group">
        <input [type]="showPassword ? 'text' : 'password'" class="form-control" formControlName="newPassword" value=""
          maxlength="250" placeholder="New Password" [ngClass]="{'invalid' : newPassword.dirty && newPassword.invalid && ngForm.submitted}"
          required>
          <div class="input-group-append" (click)="togglePassword('password')">
            <span class="input-group-text h-100"> <fa-icon [icon]="showPassword ? faEye : faEyeSlash"></fa-icon></span>
          </div>
        </div>
      </div>

      @if (newPassword.dirty && newPassword.invalid && ngForm.submitted) {
        <div class="alert alert-danger m-1">
          Enter a valid new password.
        </div>
      }

      <div class="form-group col-md-12 pb-2 mt-3">
        <label class="required" for="confirmPassword">Reenter Password</label>
        <div class="input-group">
          <input formControlName="confirmPassword" maxlength="250" value="" class="form-control"
            placeholder="Confirm new password" [type]="showConfirmPassword ? 'text' : 'password'" required
            [ngClass]="{'invalid' : confirmPassword.invalid && ngForm.submitted}" />
            <div class="input-group-append" (click)="togglePassword('confirm')">
              <span class="input-group-text h-100"> <fa-icon
              [icon]="showConfirmPassword ? faEye : faEyeSlash"></fa-icon></span>
            </div>
          </div>
        </div>

        @if (ngForm.submitted && changePasswordForm.controls['confirmPassword'].errors?.['passwordMismatch']) {
          <div
            class="alert alert-danger m-1">
            Passwords do not match.
          </div>
        }

        <div class="row white-bg">
          <div class="col mt-2">
            <span><b>Password requirements</b></span>
            <span class="d-flex mt-2 pb-3">
              Passwords must be at least 8 characters in length and
              contain at least 1 of each of the following character types:
            </span>
            <ul>
              <li>Lower case letters (i.e. a-z)</li>
              <li>Upper case letters (i.e. A-Z)</li>
              <li>Numbers (i.e. 0-9)</li>
              <li>Special Characters (i.e. !&#64;#$%^*()_~-=`{{ "[]:<>?,.//" }})</li>
              <li>Note: Special Characters & and + are not permitted</li>
            </ul>
          </div>
        </div>

        <button type="submit" class="btn btn-primary mt-4">Update</button>
      </form>

    </div>